import { API_AUTH } from "./common";

const CheckNoXauApi = {
  checkNoXau: (sodienthoai,cccd) => API_AUTH.get(`kiem-tra-no-xau?sodienthoai=${sodienthoai}&cccd=${cccd}`, {}),
};

export default CheckNoXauApi;
